export const boxShadow = {
  s: "0 2px 12px rgba(0, 0, 0, 0.25)",
  m: "0 4px 24px rgba(0, 0, 0, 0.25)",
  l: "0 8px 32px rgba(0, 0, 0, 0.25)",
  xl: "0 8px 64px rgba(0, 0, 0, 0.25)",
};
